<template>
  <b-card no-body class="mb-4 p-2 border-0 shadow">
    <b-card-header header-tag="header" class="p-0 border-0" role="tab">
      <h5 class="p-2">
        <i class="fa fa-map-marker" />
        UBICACIONES
      </h5>
    </b-card-header>
    <b-card-body class="py-3 px-0">
      <b-row>
        <b-col sm="8">
          <b-form-group>
            <b-input-group>
              <b-form-input
                name="nombre"
                type="text"
                placeholder="Buscar..."
                v-model="filtro.ubicacion"
                class="text-uppercase"
                @keypress.enter="listarUbicaciones"
              />
              <b-input-group-append>
                <b-button @click="limpiarUbicaciones" class="btn btn-default">
                  <i class="fa fa-eraser fa-lg" />
                  <span class="d-none d-md-inline-block"> Limpiar</span>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col sm="4">
          <b-button
            v-if="validarPermisoComponente('empresa-editar-ubicaciones')"
            variant="primary"
            class="float-right"
            @click="verModal"
            v-b-modal.modal-1
          >
            Crear nueva ubicación
          </b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-table
            responsive
            striped
            hover
            small
            :items="ubicaciones.data"
            :fields="columnas"
            thead-tr-class="table-active"
            class="mb-2"
          >
            <template v-slot:cell(ubicacion_padre)="data">
              <div
                v-if="
                  data.item.ubicacion_empresa &&
                  data.item.ubicacion_empresa.get_parent[0] &&
                  data.item.ubicacion_empresa.get_parent[0].get_ubicacion &&
                  data.item.ubicacion_empresa.get_parent[0].get_ubicacion.descripcion
                "
              >
                {{ data.item.ubicacion_empresa.get_parent[0].get_ubicacion.descripcion }}
              </div>
            </template>

            <template v-slot:cell(estado)="data">
              <b-badge v-if="data.item.active" variant="primary" v-text="'Activa'" />
              <b-badge v-else variant="danger" v-text="'Inactiva'" />
            </template>

            <template v-slot:cell(actions)="data">
              <el-tooltip content="Editar" placement="bottom" effect="light">
                <a
                  class="botonProduct text-dark mr-3"
                  @click="editarUbicacion(data.item)"
                >
                  <i class="fa fa-edit"></i>
                </a>
              </el-tooltip>

              <el-tooltip
                :content="!!data.item.active ? 'Inactivar' : 'Activar'"
                placement="bottom"
                effect="light"
              >
                <a class="botonProduct" @click="eliminarUbicacion(data.item)">
                  <i class="fa fa-close text-danger" v-if="!!data.item.active" />
                  <i class="fa fa-check text-success" v-else />
                </a>
              </el-tooltip>
            </template>
          </b-table>

          <el-pagination
            v-if="ubicaciones.data && !!ubicaciones.data.length"
            v-model="filtro.page"
            @size-change="listarUbicaciones"
            @current-change="listarUbicaciones"
            :current-page.sync="filtro.page"
            class="float-right"
            :page-size.sync="filtro.perPage"
            :page-sizes="[10, 30, 50, 100]"
            layout="total, sizes, prev, pager, next"
            :total="ubicaciones.total"
          />
        </b-col>
      </b-row>
    </b-card-body>

    <b-modal
      v-model="modal_ubicaciones.ver"
      title="Actualizar ubicación"
      hide-footer
      size="xl"
      static
    >
      <form @submit.prevent="validarFormularioUbicaciones" data-vv-scope="updateLocation">
        <b-row class="mt-4">
          <b-col sm="6">
            <b-form-group>
              <label for="id_nivel">Nivel de Ubicación</label><br />
              <el-select
                id="id_nivel"
                name="id_nivel"
                v-model="selectedUbicacion.slq_locations_level_id"
                data-vv-as=" "
                size="sm"
                v-validate="'required'"
                @change="validateLevel()"
              >
                <el-option
                  v-for="nivelActivo in nivelesActivos.data"
                  :label="nivelActivo.description"
                  :value="nivelActivo.id"
                  :key="nivelActivo.id"
                />
              </el-select>
              <span class="text-danger span-error small">
                {{ errors.first("updateLocation.id_nivel") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <label for="descripcion">Descripción Ubicación</label>
              <b-form-input
                id="descripcion"
                size="sm"
                type="text"
                name="descripcion"
                class="text-uppercase"
                v-model="selectedUbicacion.description"
                data-vv-as=" "
                v-validate="'required'"
              >
              </b-form-input>
              <span class="text-danger span-error small">
                {{ errors.first("updateLocation.descripcion") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-checkbox
              v-model="selectedUbicacion.parent"
              switch
              size="lg"
              :disabled="
                !this.levelSelected || this.levelSelected.level === 1 || disabled
              "
              >Editar padre</b-form-checkbox
            >
          </b-col>
          <b-col sm="6" v-if="selectedUbicacion.parent">
            <b-form-group>
              <label for="id_nivel">Ubicación padre</label><br />
              <el-select
                id="parent"
                name="parent"
                v-model="selectedUbicacion.slq_location_id"
                data-vv-as=" "
                size="sm"
                v-validate="
                  this.selectedUbicacion.parent
                    ? 'required'
                    : '' || this.levelSelected.level > 1
                    ? 'required'
                    : ''
                "
              >
                <el-option label="Ninguno" :value="null" />
                <el-option
                  v-for="locationActive in locations"
                  :label="
                    locationActive.description +
                    '  -  Nivel ' +
                    locationActive.location_level.level
                  "
                  :value="locationActive.id"
                  :key="locationActive.id"
                />
              </el-select>
              <span class="text-danger span-error small">
                {{ errors.first("updateLocation.parent") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="6" v-if="countriesWithEnterprises.length">
            <b-form-group>
              <label for="id_nivel">País</label><br />
              <el-select
                id="country"
                name="country"
                v-model="country_id"
                data-vv-as=" "
                size="sm"
                clearable
              >
                <el-option
                  v-for="country in countriesWithEnterprises"
                  :label="country.name"
                  :value="country.id"
                  :key="country.id"
                />
              </el-select>
            </b-form-group>
          </b-col>

          <b-col sm="6" v-if="countriesWithEnterprises.length && enterprises.length">
            <b-form-group>
              <label for="id_nivel">Enterprise</label><br />
              <el-select
                id="enterprise"
                name="enterprise"
                v-model="enterprise_id"
                data-vv-as=" "
                size="sm"
                v-validate="this.country_id ? 'required' : ''"
                clearable
              >
                <el-option
                  v-for="enterprise in enterprises"
                  :label="enterprise.name"
                  :value="enterprise.id"
                  :key="enterprise.id"
                />
              </el-select>
              <span class="text-danger span-error small">
                {{ errors.first("crear.enterprise") }}
              </span>
            </b-form-group>
          </b-col>

          <b-col sm="6" v-if="groups.length && enterprises.length">
            <b-form-group>
              <label for="id_nivel">Grupo</label><br />
              <el-select
                id="group"
                name="group"
                v-model="group_id"
                data-vv-as=" "
                size="sm"
                clearable
                v-validate="this.enterprise_id ? 'required' : ''"
              >
                <el-option
                  v-for="group in groups"
                  :label="group.name"
                  :value="group.id"
                  :key="group.id"
                />
              </el-select>
              <span class="text-danger span-error small">
                {{ errors.first("crear.group") }}
              </span>
            </b-form-group>
          </b-col>

          <b-col sm="6" v-if="groups.length && businesses.length">
            <b-form-group>
              <label for="id_nivel">Businesses</label><br />
              <el-select
                id="business"
                name="business"
                v-model="business_id"
                data-vv-as=" "
                size="sm"
                clearable
                v-validate="this.group_id ? 'required' : ''"
              >
                <el-option
                  v-for="business in businesses"
                  :label="business.name"
                  :value="business.id"
                  :key="business.id"
                />
              </el-select>
              <span class="text-danger span-error small">
                {{ errors.first("crear.business") }}
              </span>
            </b-form-group>
          </b-col>

          <b-col sm="6" v-if="subBusinesses.length && businesses.length">
            <b-form-group>
              <label for="id_nivel">Sub Businesses</label><br />
              <el-select
                id="sub_business"
                name="sub_business"
                v-model="selectedUbicacion.slq_business_sub_business_id"
                data-vv-as=" "
                size="sm"
                clearable
                v-validate="this.business_id ? 'required' : ''"
              >
                <el-option
                  v-for="sub_business in subBusinesses"
                  :label="sub_business.name"
                  :value="sub_business.id"
                  :key="sub_business.id"
                />
              </el-select>
              <span class="text-danger span-error small">
                {{ errors.first("crear.sub_business") }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button
              @click="validateFormUpdateLocation"
              variant="primary"
              class="btn btn-primary float-right"
            >
              Guardar
            </b-button>
            <b-button class="btn btn-default float-right mr-2" @click="cancel()">
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </form>
    </b-modal>
    <modal-ubicacion />
  </b-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import modalUbicacion from "./modal";
import { validarPermisoComponente } from "@/plugins/acl";

export default {
  name: "ubicaciones",
  components: {
    modalUbicacion,
  },
  data() {
    return {
      level: null,
      locations: [],
      disabled: false,
      levelSelected: { level: null, id: null },
      country_id: null,
      enterprise_id: null,
      group_id: null,
      business_id: null,
      validarPermisoComponente: validarPermisoComponente,
    };
  },
  watch: {
    country_id: {
      handler: async function (val) {
        if (val) {
          await this.getCountryByIdAndCompanyId({
            country_id: val,
            company_id: this.$route.params.id,
          });
        } else {
          this.setEnterprises([]);
          this.setGroups([]);
          this.setBusinesses([]);
          this.setSubBusinesses([]);
          this.enterprise_id = null;
          this.group_id = null;
          this.business_id = null;
        }
      },
      deep: true,
    },
    enterprise_id: {
      handler: async function (val) {
        if (val) {
          await this.getEnterpriseByIdAndCompanyId({
            enterprise_id: val,
            company_id: this.$route.params.id,
          });
        } else {
          this.setGroups([]);
          this.setBusinesses([]);
          this.setSubBusinesses([]);
          this.group_id = null;
          this.business_id = null;
        }
      },
      deep: true,
    },
    group_id: {
      handler: async function (val) {
        if (val) {
          await this.getGroupByIdAndCompanyId({
            group_id: val,
            company_id: this.$route.params.id,
          });
        } else {
          this.setBusinesses([]);
          this.setSubBusinesses([]);
          this.business_id = null;
        }
      },
      deep: true,
    },
    business_id: {
      handler: async function (val) {
        if (val) {
          await this.getBusinessByIdAndCompanyId({
            business_id: val,
            company_id: this.$route.params.id,
          });
        } else {
          this.setSubBusinesses([]);
          this.selectedUbicacion.slq_business_sub_business_id = null;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("location", [
      "ubicaciones",
      "selectedUbicacion",
      "filtro",
      "modal_ubicaciones",
      "asociar",
      "nivelesActivos",
      "locationsActive",
    ]),
    ...mapState("countries", ["countriesWithEnterprises"]),
    ...mapState("enterprises", ["enterprises"]),
    ...mapState("groups", ["groups"]),
    ...mapState("businesses", ["businesses", "subBusinesses"]),
    columnas(){
        const columnasBase = [
            {
                key: "location_level.level",
                label: "Nivel",
                sortable: true,
                tdClass: "text-center",
                thClass: "text-center",
                thStyle: "width: 80px; max-width:80px",
            },
            {
                key: "location_level.description",
                label: "Nombre_de_nivel",
                tdClass: "text-uppercase",
                sortable: true,
            },
            {
                key: "description",
                label: "Ubicación",
                sortable: true,
            },
            {
                key: "parent_location.description",
                label: "Ubicación_padre",
                sortable: true,
            },
            {
                key: "estado",
                label: "Estado",
                sortable: true,
                tdClass: "text-center",
                thClass: "text-center",
                thStyle: "width: 120px; max-width:120px",
            },
        ];

        if(this.validarPermisoComponente('empresa-editar-ubicaciones')){
            columnasBase.push({
                key: "actions",
                label: "Opciones",
                tdClass: "text-center",
                thClass: "text-center",
                thStyle: "width: 120px; max-width:120px",
            });
        }

        return columnasBase;
    }
  },
  methods: {
    ...mapActions("location", [
      "listarUbicaciones",
      "listarNivelActivos",
      "updateUbicacion",
      "crearUbicacionEmpresa",
      "arbolUbicacionesEmpresa",
      "verListaUbicaciones",
      "deleteUbicacion",
      "listLocationsActive",
    ]),
    ...mapActions("countries", ["getCountriesToCompanyId"]),
    ...mapMutations("location", [
      "resetFiltroUbicaciones",
      "establecerAsociar",
      "setModal",
      "resetSelectedUbicacion",
      "establecerModalUbicaciones",
      "setSelectedUbicacion",
      "setIdUbicacion",
      "setIdParent",
      "setEnlazar",
      "setPaso",
    ]),
    ...mapActions("countries", ["getCountryByIdAndCompanyId"]),
    ...mapActions("enterprises", ["getEnterpriseByIdAndCompanyId"]),
    ...mapActions("groups", ["getGroupByIdAndCompanyId"]),
    ...mapActions("businesses", ["getBusinessByIdAndCompanyId"]),

    ...mapMutations("enterprises", ["setEnterprises"]),
    ...mapMutations("groups", ["setGroups"]),
    ...mapMutations("businesses", ["setSubBusinesses", "setBusinesses"]),
    ...mapMutations("countries", ["setCountriesWithEnterprises"]),

    async limpiarUbicaciones() {
      this.resetFiltroUbicaciones();
      await this.listarUbicaciones();
    },
    async eliminarUbicacion(ubicacion) {
      if (ubicacion.parent_location) {
        ubicacion.parent = true;
      } else {
        ubicacion.parent = false;
      }
      this.setSelectedUbicacion(ubicacion);
      await this.deleteUbicacion();
      this.resetSelectedUbicacion();
    },
    async verUbicacion(id) {
      this.setFiltro(id);
      this.setFiltroNivel(id);
      await this.listarUbicaciones(this.$route.params.id);
      await this.listarUbicacionesEmpresa(this.$route.params.id);
    },
    async verModal() {
      this.resetSelectedUbicacion();
      this.setCountriesWithEnterprises([]);
      this.setEnterprises([]);
      this.setGroups([]);
      this.setBusinesses([]);
      this.setSubBusinesses([]);
      await this.listarNivelActivos();
      await this.listLocationsActive();
      await this.getCountriesToCompanyId(this.$route.params.id);

      if (!this.countriesWithEnterprises.length) {
        this.setEnterprises([]);
        this.setGroups([]);
        this.setBusinesses([]);
        this.setSubBusinesses([]);
      }

      this.setModal(true);
    },

    async editarUbicacion(ubicacion) {
      this.resetSelectedUbicacion();
      this.setCountriesWithEnterprises([]);
      this.setEnterprises([]);
      this.setGroups([]);
      this.setBusinesses([]);
      this.setSubBusinesses([]);
      this.country_id = null;
      this.enterprise_id = null;
      this.group_id = null;
      this.business_id = null;
      if (ubicacion.parent_location) {
        ubicacion.parent = true;
      } else {
        ubicacion.parent = false;
      }
      await this.listarNivelActivos();
      await this.listLocationsActive();
      this.setSelectedUbicacion(ubicacion);
      this.establecerModalUbicaciones(true);
      this.validateLevel();
      if (this.selectedUbicacion.slq_business_sub_business_id) {
        this.country_id = this.selectedUbicacion.business_sub_business.business.group.enterprise.slq_country_id;
        this.enterprise_id = this.selectedUbicacion.business_sub_business.business.group.slq_enterprise_id;
        this.group_id = this.selectedUbicacion.business_sub_business.business.slq_group_id;
        this.business_id = this.selectedUbicacion.business_sub_business.slq_business_id;
        await this.getCountriesToCompanyId(this.$route.params.id);
        await this.getCountryByIdAndCompanyId({
          country_id: this.selectedUbicacion.business_sub_business.business.group
            .enterprise.slq_country_id,
          company_id: this.$route.params.id,
        });
      }
    },
    async validateFormUpdateLocation() {
      await this.$validator.validateAll("updateLocation").then(async (validado) => {
        if (validado) {
          await this.updateUbicacion();
          this.resetSelectedUbicacion();
          this.establecerModalUbicaciones(false);
        }
      });
      this.level = null;
      this.locations = [];
      this.disabled = false;
      this.levelSelected = { level: null, id: null };
    },
    async verModalUbicacion(datos) {
      this.establecerAsociar(true);
      this.setEnlazar(datos.get_nivel);
      this.setIdUbicacion(datos.id);
      await this.verListaUbicaciones();
      this.setPaso(1);
      this.setModal(true);
      await this.arbolUbicacionesEmpresa();
    },
    async cancel() {
      this.resetSelectedUbicacion();
      this.establecerModalUbicaciones(false);
      this.level = null;
      this.locations = [];
      this.disabled = false;
      this.levelSelected = { level: null, id: null };
    },
    validateLevel() {
      let locationParent = null;
      this.nivelesActivos.data.forEach((element) => {
        if (element.id === this.selectedUbicacion.slq_locations_level_id) {
          this.levelSelected.id = element.id;
          this.levelSelected.level = element.level;
        }
      });

      if (this.levelSelected.level > 1) {
        this.locations = this.locationsActive.filter(
          (item) => item.location_level.level === this.levelSelected.level - 1
        );

        this.selectedUbicacion.parent = true;
        this.disabled = true;

        locationParent = this.locationsActive.filter(
          (item) => item.id === this.selectedUbicacion.slq_location_id
        );

        if (
          locationParent.length > 0 &&
          locationParent[0].location_level &&
          locationParent[0].location_level.level + 1 !== this.levelSelected.level
        ) {
          this.selectedUbicacion.slq_location_id = null;
        }
      } else {
        this.locations = this.locationsActive;
        this.selectedUbicacion.parent = false;
      }
    },
  },
};
</script>

<style scoped></style>
